import { useNavigate } from "react-router-dom";
import { AdminTemplate, TaxRatesList } from "../../components";

export const TaxRatesPage = () => {
  const navigate = useNavigate();
  const handleAddButton = () =>
    navigate("/add-tax-rate", { state: null });

  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "Vergi Oranı Listeleme",
        onClickAddButton: handleAddButton,
      }}
    >
     <TaxRatesList />
    </AdminTemplate>
  );
};
